import React from 'react'
import { change as changeFieldValue, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import $ from 'jquery';
import buscarVeiculos from '../../actions/veiculo/buscarVeiculos';
import MapasVeiculos from '../mapa-veiculo/MapasVeiculos';
import Titulo from '../comum/Titulo';
import MapaVeiculo from '../mapa-veiculo/MapaVeiculo';
import { alterouPagina } from '../../util/filtros';
import buscarMapasVeiculos from '../../actions/mapa-veiculo/buscarMapasVeiculos';
import alterarMapaSelecionadoVeiculo from '../../actions/veiculo/alterarMapaSelecionadoVeiculo';

export class ModalSelecionarMapaVeiculo extends React.Component {
    constructor(props) {
        super(props);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.state = {
            marcacaoLida: false,
            mapaSelecionado: ''
        };
    }
    
    componentDidUpdate(prevProps) {
        if (alterouPagina(this.props, prevProps) || this.props.filtrosMapaVeiculo !== prevProps.filtrosMapaVeiculo) {
            this.props.buscarMapasVeiculos(this.props.filtrosMapaVeiculo, this.props.paginaAtual, this.props.registrosPorPagina);
        }
    }


    limparFormulario() {
        this.setState({ mapaSelecionado: null })
    }

    selecionarMapa(mapa) {        
        if (this.state.mapaSelecionado || this.props.mapaVeiculo) {
            this.setState({ mapaSelecionado: null })
            this.props.changeFieldValue('formularioPainelCadastroVeiculo',
                'mapaVeiculo', null);
        } else {
            this.setState({ mapaSelecionado: mapa })
        }
    }

    exibirMapas() {
        if (this.state.mapaSelecionado) {
            return <MapaVeiculo mapaVeiculo={this.state.mapaSelecionado} selecionar={this.selecionarMapa.bind(this)}
                selecionado={this.state.mapaSelecionado} />
        }        
        if (this.props.mapaVeiculo) {
            return <MapaVeiculo mapaVeiculo={this.props.mapaVeiculo} selecionar={this.selecionarMapa.bind(this)}
                selecionado={this.props.mapaVeiculo} />
        }        
        return <MapasVeiculos selecionar={this.selecionarMapa.bind(this)} selecionado={this.state.mapaSelecionado} />
    }

    fecharModal() {
        $('#modalSelecionarMapaVeiculo')
            .modal('hide');
        $('#modalSelecionarMapaVeiculo')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.setState({ mapaSelecionado: null });
    }

    limparMensagem() {
        this.setState({ mensagem: undefined })
    }

    confirmar() {
        const mapa = this.props.mapaVeiculo ? this.props.mapaVeiculo: this.state.mapaSelecionado;
        this.props.alterarMapaSelecionadoVeiculo(mapa);
        this.fecharModal();
    }

    render() {        
        const mapaVeiculoSelecionado = this.props.mapaVeiculo ? this.props.mapaVeiculo : this.state.mapaSelecionado
        return (
            <div className="modal fade show" id='modalSelecionarMapaVeiculo' role='dialog'
                aria-labelledby='modalSelecionarMapaVeiculo' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>{'Selecionar modelo de veículo'}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                onClick={this.limparFormulario}>
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">                       
                            <div className='mt-4'>
                                <Titulo texto="Selecionar modelo de veículo" cssText='text-center' />
                                {this.exibirMapas()}
                            </div>
                            <div className="modal-footer">
                                <button type="submit" onClick={() => this.confirmar()}
                                    disabled={!mapaVeiculoSelecionado}
                                    className="btn btn-laranja">Confirmar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {        
        mapaVeiculo: formValueSelector('formularioPainelCadastroVeiculo')(state, 'mapaVeiculo'),        
        paginaAtual: state.paginaAtualMapasVeiculos,
        registrosPorPagina: state.registrosPorPaginaMapasVeiculos,
        empresaSelecionada: state.empresaSelecionada,
        filtrosMapaVeiculo: state.filtrosMapaVeiculo
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,        
        alterarMapaSelecionadoVeiculo,
        buscarMapasVeiculos,
        buscarVeiculos
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioPainelCadastroVeiculo',    
})(ModalSelecionarMapaVeiculo));
